module.exports = __webpack_public_path__ + "img/news.c76dad01.png";